import { render, staticRenderFns } from "./Pingram.vue?vue&type=template&id=5f26e8da&scoped=true"
import script from "./Pingram.vue?vue&type=script&lang=js"
export * from "./Pingram.vue?vue&type=script&lang=js"
import style0 from "./Pingram.vue?vue&type=style&index=0&id=5f26e8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f26e8da",
  null
  
)

export default component.exports